export default {"src":"/_next/static/media/Accutrend.154ff121.svg","height":60,"width":130};